// The default brand for every staff sign-in page without a (valid) airline code: Vamos itself,
// as on itsvamos.com. Deliberately NOT the "Air Vamos" demo airline (company code AV), which is
// just another tenant and is branded like any airline at /login/av.
export const VAMOS_BRAND = Object.freeze({
  code: null,
  name: 'Vamos',
  logo: '/img/logo.svg',
  icon: '/img/icon.png',
  color1: '#075FF7',
  color2: '#8D07F7',
})

export const DEFAULT_FAVICON = '/favicon.ico'
